var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"lesson-script-container"},[(_setup.loadingScripts)?_c(_setup.LoadingSpinner):_vm._e(),_c('div',{ref:"elRef",staticClass:"lesson-script",domProps:{"innerHTML":_vm._s(_vm.content)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }